import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Search, ArrowRight, Loader } from 'lucide-react';
import AnnonceCard from '../components/AnnonceCard';
import { AnnonceListItem } from '../data/annonces';
import { searchAnnonces } from '../api/services/AnnonceService';
import './Home.css';

const Home: React.FC = () => {
  const [query, setQuery] = useState('');
  const navigate = useNavigate();
  const [recentAnnonces, setRecentAnnonces] = useState<AnnonceListItem[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchRecent = async () => {
      try {
        const response = await searchAnnonces({ page: 1, page_size: 5 });
        const data = response.data;
        if (data.success) {
          setRecentAnnonces(data.results || []);
        }
      } catch (err) {
        console.error('Erreur chargement annonces récentes:', err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchRecent();
  }, []);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (query.trim()) {
      navigate(`/recherche?q=${encodeURIComponent(query.trim())}`);
    } else {
      navigate('/recherche');
    }
  };

  return (
    <div className="home">
      {/* Hero */}
      <section className="hero">
        <div className="hero-decor hero-decor-1"></div>
        <div className="hero-decor hero-decor-2"></div>
        <div className="hero-decor hero-decor-3"></div>
        <div className="hero-decor hero-decor-4"></div>
        <div className="hero-content">
          <h1 className="hero-title">
            <span className="hero-title-orange">Annonces Légales</span><br />
            de Côte d'Ivoire
          </h1>
          <p className="hero-subtitle">
            Recherchez et consultez les annonces légales publiées en Côte d'Ivoire.<br />
            Création, modification, dissolution d'entreprises - toutes les informations officielles.
          </p>
          <div className="hero-search-wrapper">
            <form className="hero-search" onSubmit={handleSearch}>
              <input
                type="text"
                placeholder="Rechercher une entreprise, un RCCM, un mot-clé..."
                value={query}
                onChange={(e) => setQuery(e.target.value)}
              />
              <button type="submit">
                <Search size={20} />
              </button>
            </form>
          </div>
          <Link to="/recherche" className="btn-advanced">
            Recherche avancée <ArrowRight size={16} />
          </Link>
        </div>
      </section>

      <div className="hero-separator"></div>

      {/* Dernières annonces */}
      <section className="recent-section">
        <div className="section-container">
          <div className="recent-header">
            <h2 className="section-title">Dernières annonces</h2>
            <Link to="/recherche" className="voir-tout">
              Voir tout <ArrowRight size={16} />
            </Link>
          </div>

          {isLoading ? (
            <div style={{ textAlign: 'center', padding: '40px' }}>
              <Loader size={32} className="spin" />
              <p style={{ marginTop: '12px', color: '#888' }}>Chargement des annonces...</p>
            </div>
          ) : recentAnnonces.length > 0 ? (
            <div className="annonces-grid">
              {recentAnnonces.map((a, index) => (
                <AnnonceCard key={`${a.nom_societe}-${a.date_publication}-${index}`} annonce={a} index={index} />
              ))}
            </div>
          ) : (
            <div style={{ textAlign: 'center', padding: '40px', color: '#888' }}>
              <p>Aucune annonce disponible pour le moment.</p>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Home;
